$(document).ready(function () {

    var initializeStateMap = function($self){
        var stateDataTable = new google.visualization.DataTable();
        var stateChart = new google.visualization.GeoChart($self.$stateMap[0]); 
        var stateOptions = {
            chartArea: {
                width: $self.mapDimensions.x,
                height: $self.mapDimensions.y
            },
            backgroundColor: {
                fill:"#FFFFFF",
                stroke:"#FFFFFF",
                strokeWidth:0
            },
            colorAxis: {
                minValue: 0,
                maxValue: 12,
                colors: [
                    //State
                    "#000000", //2010
                    "#000001", //2011
                    "#000002", //2012
                    "#000003", //2013
                    "#000004", //2014
                    "#000005", //2015
                    "#000006", //2016
                    "#000007", //2017
                    "#000008", //2018
                    "#000009", //2019
                    "#000010", //2020
                    "#000011", //2021
					"#000012", //2022

                ]
            },
            legend: "none",
            datalessRegionColor: "#f5f5f5",
            displayMode: "regions",  
            resolution: "provinces",
            sizeAxis: {
                minValue: 1, 
                maxValue:1,
                minSize:10,
                maxSize: 10
            },
            region:"US",
            keepAspectRatio: true,
            width:$self.mapDimensions.x,
            height:$self.mapDimensions.y,
            tooltip: {
                trigger: "focus",
                isHtml: true
            }
        };
        stateDataTable.addColumn("string", "State");
        stateDataTable.addColumn("number", "Allied");
        stateDataTable.addColumn("number", "index");
        stateDataTable.addRows($self.stateData);
        
        google.visualization.events.addListener(stateChart, "ready", function () {
            onStateMapReady($self);
        });
        
        stateChart.draw(stateDataTable, stateOptions);
    }

    var initializeCityMap = function($self){
        var cityDataTable = new google.visualization.DataTable();
        var cityChart = new google.visualization.GeoChart($self.$cityMap[0]); 
        var cityOptions = {
            legend: "none",
            colorAxis: {
                minValue: 0,
                maxValue: 12,
                colors: [
                    "#000000", //2010
                    "#000001", //2011
                    "#000002", //2012
                    "#000003", //2013
                    "#000004", //2014
                    "#000005", //2015
                    "#000006", //2016
                    "#000007", //2017
                    "#000008",  //2018
                    "#000009",  //2019
                    "#000010",  //2020
                    "#000011",  //2021
					 "#000012", //2022
                ]
            },
            datalessRegionColor: "#f5f5f5",
            displayMode: "markers", 
            enableRegionInteractivity: "true", 
            resolution: "provinces",
            sizeAxis: {minValue: 1, maxValue:1,minSize:5,  maxSize: 5},
            region:"US",
            keepAspectRatio: true,
            width:$self.mapDimensions.x,
            height:$self.mapDimensions.y
        };

        cityDataTable.addColumn("number", "Lat");
        cityDataTable.addColumn("number", "Long");
        cityDataTable.addColumn("number", "value");
        cityDataTable.addColumn("number", "index");
        cityDataTable.addRows($self.cityData);

        google.visualization.events.addListener(cityChart, "ready", function () {
            onCityMapReady($self);
        });

        cityChart.draw(cityDataTable, cityOptions);
    }

    var onStateMapReady = function ($self) {
        //HIDE ALASKA
        $self.$stateMap.find("g").eq(4).css("display", "none");
        $self.$stateMap.find("g").eq(5).css("display", "none");

        // Apply dotted pattern to map
        $self.$stateMap.find('g path').each(function(){
            if(!$(this).hasClass('pattern-overlay')){
                var element = $(this);
                var dValue = element.attr('d');
                var fillColor = element.attr('fill');
                // create dotted pattern path, set attributes, and insert it after current path
                var newPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                newPath.setAttribute('class', 'pattern-overlay');
                if(fillColor == '#f5f5f5'){
                    newPath.classList.add('dataless');
                }
                newPath.setAttribute('d', dValue);
                element.after(newPath);
            }
        });
        $self.addClass('module-ready');
    }

    var onCityMapReady = function($self){
        var circles = [];

        $self.$cityMap.show();
        $self.$cityMap.find("circle").each(function () {
            circles.push({
                left: $(this).offset().left - $self.$cityMap.offset().left,
                top: $(this).offset().top - $self.$cityMap.offset().top,
                fillColor: $(this).attr('fill')
            });
        });

        $self.$cityMap.hide();
        $self.$stateMap.find('.city-county-dot').remove();
        $.each(circles, function (i, circle) {
            var icon = "<div class='city-county-dot' fill='"+circle.fillColor+"' style='top:"+circle.top+"px;left:"+circle.left+"px;'></div>";
            $self.$stateMap.append(icon);
        });
    }

    var animateIndicator = function($self){
        $self.$timelineList.$indicator.css('transform', 'translateX('+parseFloat($self.$timelineList.find('li.active-year').position().left+(($self.$timelineList.find('li.active-year').width() - $self.$timelineList.$indicator.width())/2)).toFixed(2)+'px)');
    }

    var initializeModule = function($self){
        if($self.moduleData && $self.moduleData.data){
            $self.moduleData.data.forEach(function(el, i){
                var dataKey = $self.moduleData.data_key;
                if(el.strategy_implementation_years[dataKey]){
                    if(el.geo_type == "State" || el.geo_type == "Regional Consortium"){
                        var initVal = el.geo_type == "State" ? 0 : el.geo_type == "Regional Consortium" ? 0 : 0;
                        if(parseInt(el.strategy_implementation_years[dataKey]) >= 2020 && el.geo_type == "State"){
                            initVal = 10;
                        }
                        var value = initVal + parseInt(parseInt(el.strategy_implementation_years[dataKey]) % 10);
                        $self.stateData.push([el.state.label, value, i]);
                    }else if(el.geo_type == "City/County"){
                        var value = parseInt(parseInt(el.strategy_implementation_years[dataKey]) % 10);
                        $self.cityData.push([parseFloat(el.city.lat), parseFloat(el.city.lng),value, i]);
                    }
                }
            });

            initializeStateMap($self);
            initializeCityMap($self);
    
            $(window).resize(function () {
                $self.mapDimensions = {
                    x: $self.$stateMap.width() + parseInt($self.$stateMap.width() * 0.221),
                    y: ($self.$stateMap.width() / $self.mapDimensionRatio) + parseInt(($self.$stateMap.width() / $self.mapDimensionRatio) * 0.329),
                };    
                initializeStateMap($self);
                initializeCityMap($self);
    
                //animate indicator to correct position
                animateIndicator($self);
            });
        }
    }

    $('[alliance-timeline-map]').each(function(){
        var $self = $(this);
        $self.moduleData = $self.attr('alliance-timeline-map').length == 0 ? null : JSON.parse($self.attr('alliance-timeline-map'));
        $self.stateData = [];
        $self.cityData = [];
        $self.mapContainer = $self.find('.alliance-map-container');
        $self.$stateMap = $self.find('[data-map-states]');
        $self.$cityMap = $self.find('[data-map-cities]');
        $self.$stateBox = $self.find('.state-box');
        $self.$timelineList = $self.find('.timeline-container ul');
        $self.$timelineDropdown = $self.find('.mobile-dropdown-container select');
        $self.$timelineList.$indicator = $self.$timelineList.find('.indicator');
        $self.mapDimensionRatio = 1.907; //divide width by this ratio to get correct height
        $self.mapDimensions = {
            x: $self.$stateMap.width() + parseInt($self.$stateMap.width() * 0.221),
            y: ($self.$stateMap.width() / $self.mapDimensionRatio) + parseInt(($self.$stateMap.width() / $self.mapDimensionRatio) * 0.329),
        };

        $self.$timelineList.find('li').on('mouseenter click', function(){
            var yearValue = $(this).attr('data-map-year');
            $(this).addClass('active-year');
            $self.$timelineList.find('li').not(this).removeClass('active-year');
            $self.$stateMap.attr('data-map-for', yearValue);

            //animate indicator            
            animateIndicator($self);

            //update list in state-box container
            $self.$stateBox.attr('data-map-for', yearValue);
        });
        //make 2018 first one selected
        $self.$timelineList.find('li:last-of-type').trigger('click');

        $self.$timelineDropdown.on('change', function(){
            var selectedYear = $(this).find('option:selected').val();
            $self.$timelineList.find('li[data-map-year="'+selectedYear+'"]').trigger('click');
        })

        window.loadScript('//www.google.com/jsapi?ext.js', 'google-jsapi', function() {
            google.load('visualization', '1.0', {
                packages: ['geochart'],
                callback: function() {
                    initializeModule($self);
                }
            })
        });
    });
})